import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ChatMessage } from '../../../models/chat-message';
import { EnumType } from '../../../models/enums/enum';

@Component({
  selector: 'app-chat-messages-quick-reply',
  templateUrl: './chat-messages-quick-reply.component.html',
  styleUrls: ['./chat-messages-quick-reply.component.scss']
})
export class ChatMessagesQuickReplyComponent implements OnInit {

  @Input() index: number;
  @Input() elements: any;
  @Output() onOptionMessageClicked: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() { }

  addMessage(item: any) {
    let element: ChatMessage = {
      senderName: EnumType.MessageSender.USER,
      time: new Date(),
      payload: {
        type: 'text',
        values: item.title,
        intent: item.payload
      }
    };
    this.onOptionMessageClicked.emit(element);
  }


}
